import { IconProps, SvgIcon } from "@mui/material";

const EnvelopeIcon = ({ sx }: IconProps) => {
  return (
    <SvgIcon sx={sx}>
      <svg viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.0476 3.85706L11.4848 9.31357C11.1942 9.48241 10.8641 9.57134 10.5281 9.57134C10.1921 9.57134 9.86201 9.48241 9.57143 9.31357L1 3.85706"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.1429 1H2.90476C1.85279 1 1 1.85279 1 2.90476V14.3333C1 15.3853 1.85279 16.2381 2.90476 16.2381H18.1429C19.1948 16.2381 20.0476 15.3853 20.0476 14.3333V2.90476C20.0476 1.85279 19.1948 1 18.1429 1Z"
          stroke="#0D579B"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </SvgIcon>
  );
};

export default EnvelopeIcon;
